import { makeStyles } from "@saleor/macaw-ui";

const useStyle = makeStyles(
  () => ({
    root: {
      padding: "24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    header: {
      padding: "0px 0px 24px",
      textAlign: "center"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "24px"
    },
    title: {
      fontSize: "22px",
      color: "#333",
      marginBottom: "16px"
    },
    subtitle: {
      fontSize: "18px",
      fontWeight: "normal",
      color: "#333"
    },
    btnAction: {
      color: "white",
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",
      "&:hover": {
        background:
          "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important"
      }
    }
  }),
  { name: "stylesCreateErrorView" }
);

export default useStyle;
